import { styled } from "goober";
import { Icon } from "../Icon";
import { Text } from "../Text";
import { DownloadButton } from "./DownloadButton";
import type { FileRenderControl } from "./types";
import { useFileActions } from "./useFileActions";
import { useObjectUrl } from "./useObjectUrl";

const Container = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  width: 100%;
  height: 100%;
`;

const Frame = styled("iframe")`
  flex: 1;
  min-height: 480px;
  width: 100%;
  border-radius: 12px;
  border: 0.5px solid var(--border-alpha);
  background: var(--surface-primary);
`;

type Props = {
  url?: string;
  fileName?: string;
  onControls?: (controls: FileRenderControl[]) => void;
};

export function Pdf({ url, fileName, onControls }: Props) {
  const { blobUrl } = useObjectUrl(url);

  const downloadName = fileName ?? "output.pdf";
  const { download, downloading } = useFileActions({
    url,
    fileName: downloadName,
    onControls,
  });

  if (!blobUrl) return null;

  return (
    <Container>
      <Frame src={`${blobUrl}#toolbar=0&navpanes=0`} title={downloadName} />
      {!onControls && (
        <div style={{ marginLeft: "auto" }}>
          <DownloadButton onPress={download} disabled={!url || downloading}>
            <Icon name="arrow-down" size={12} />
            <Text variant="text-small-md">
              {downloading ? "Downloading…" : "Download"}
            </Text>
          </DownloadButton>
        </div>
      )}
    </Container>
  );
}
